// import Cookies from 'js-cookie'

// const TokenKey = 'i_total_token'

export function getToken() {
  // return Cookies.get(TokenKey)
  return localStorage.getItem('accessToken') || ''
}

export function setToken(token) {
  console.log('token', token)

  return localStorage.setItem('accessToken', token)

  // return Cookies.set(TokenKey, token)
}

export function removeToken() {
  console.log('auth removeToken')

  // return Cookies.remove(TokenKey)
  return localStorage.removeItem('accessToken')
}

export function getUserData() {
  // return Cookies.get(TokenKey)
  return JSON.parse(localStorage.getItem('userData')) || null
}

export function setUserData(userData) {
  console.log('userData', userData)
  localStorage.setItem('userAbility', JSON.stringify([{ action: 'manage', subject: 'all' }]))

  return localStorage.setItem('userData', JSON.stringify(userData))

  // return Cookies.set(TokenKey, token)
}

export function removeUserData() {
  console.log('auth UserData')
  localStorage.removeItem('userAbility')

  // return Cookies.remove(TokenKey)
  return localStorage.removeItem('userData')
}

export function getMenu() {
  // return Cookies.get(TokenKey)
  return JSON.parse(localStorage.getItem('sysMenu')) || null
}

export function setMenu(sysMenu) {
  console.log('sysMenu', sysMenu)
  if (sysMenu) return localStorage.setItem('sysMenu', JSON.stringify(sysMenu))

  // return Cookies.set(TokenKey, token)
  throw new Error('sysMenu exception')
}

export function removeMenu() {
  console.log('auth removeMenu')

  // return Cookies.remove(TokenKey)
  return localStorage.removeItem('sysMenu')
}
